import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import React from 'react';
import FieldGroup from '../../FieldGroup.jsx';

const individualStakeholderFields = [
  {
    label: 'First Name',
    key: 'firstName',
  },
  {
    label: 'Last Name',
    key: 'lastName',
  },
  {
    label: 'Email',
    key: 'email',
  },
];

const IndividualStakeholderFields = ({
  onUpdateStakeholderField,
  stakeholdersStructure,
  index,
  onDeleteStakeholder,
}) => {
  return (
    <Row>
      {individualStakeholderFields.map(({ label, key }) => (
        <Col xs={3} key={`individualField${index}${key}`}>
          <Field
            name={`individualField.${index}.${key}`}
            placeholder={`Enter ${label}`}
            type="text"
          >
            {(props) => (
              <FieldGroup
                {...props}
                value={stakeholdersStructure[index][key]}
                onChange={(event) =>
                  onUpdateStakeholderField(index, key, event.target.value)
                }
                validateWithoutTouched={!!stakeholdersStructure[index][key]}
              />
            )}
          </Field>
        </Col>
      ))}
      <Col xs={1}>
        <Button
          bsStyle="default"
          className="btn-delete"
          onClick={() => onDeleteStakeholder(index)}
        >
          Delete
        </Button>
      </Col>
    </Row>
  );
};

export default IndividualStakeholderFields;
